export default __webpack_public_path__ + "static/winter46-0171ead5c885bf0b8e61e01e6beb932d.webp";